<template>
  <PageSection :title="t('profile.editInfoForm.infoTitle')">
    <div>
      <Input
        id="first-name"
        :label="t('profile.editInfoForm.firstName')"
        :placeholder="t('profile.editInfoForm.firstName')"
        :value="formValues.first_name"
        @input="(value: string) => updateFN('first_name', value)"
        :error="t('errorMessages.fieldMandatory')"
        :show-error="invalidFields.has('first_name')"
        :readOnly="!editable || loading"
        :input-styles="!editable ? readonlyStyles : {}"
      />
      <Input
        id="last-name"
        :label="t('profile.editInfoForm.lastName')"
        :placeholder="t('profile.editInfoForm.lastName')"
        :value="formValues.last_name"
        @input="(value: string) => updateFN('last_name', value)"
        :error="t('errorMessages.fieldMandatory')"
        :show-error="invalidFields.has('last_name')"
        :readOnly="!editable || loading"
        :input-styles="!editable ? readonlyStyles : {}"
      />
      <Input
        id="email"
        :label="t('profile.editInfoForm.email')"
        :placeholder="t('profile.editInfoForm.email')"
        :error="t('errorMessages.fieldMandatory')"
        readOnly
        :input-styles="readonlyStyles"
        :value="userInfo.email"
      >
        <template #after>
          <span
            class="pe-3"
            style="
              background: #f5f5f5;
              height: 100%;
              display: flex;
              align-items: center;
            "
          >
            <LockIcon />
          </span>
        </template>
      </Input>
      <p class="caption text-grey-900">
        {{ t('profile.editInfoForm.emailChangeInfo') }}
      </p>
    </div>
  </PageSection>
</template>

<script lang="ts" setup>
  // Vue
  import { computed, defineProps } from 'vue'

  // Components
  import PageSection from '@/components/UI/PageSection.vue'
  import Input from '@/components/UI/Input.vue'

  // Icons
  import LockIcon from '@/assets/LockIcon.vue'

  // Types
  import { FormProps } from './EditInfoForm.types'

  // Translations
  import { useI18n } from 'vue-i18n'
  const { t } = useI18n()

  // Props
  defineProps<FormProps>()

  // Computed
  const readonlyStyles = computed(() => ({
    border: 'none',
    backgroundColor: '#f5f5f5',
    cursor: 'not-allowed',
  }))
</script>

<style scoped>
  .non-editable {
    border: none;
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
</style>
